import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

import {
  DROPDOWN_DEFAULT_VALUE_FOOD_TYPE,
  DROPDOWN_DEFAULT_VALUE_PRODUCTS
} from '../constants/dropdown';
import {
  generateFoodtypesByCourse,
  generateProductTypesByFilteredRecipes
} from '../utils/filter';

export const useFilterByRecipes = (
  currentCourseOption,
  currentFoodTypeOption,
  currentProductOption,
  filteredRecipesContent,
  firstCourseOption,
  firstFoodTypeOption,
  firstProductOption,
  initialFoodtypeOptions,
  productOptions,
  recipesContent,
  setCurrentCourseOption,
  setCurrentFoodTypeOption,
  setCurrentProductOption
) => {
  const [foodtypeOptions, setFoodtypeOptions] = useState(
    initialFoodtypeOptions
  );
  const [productsOptions, setProductOptions] = useState(productOptions);

  useEffect(() => {
    const foodtypesByCourseTabs = generateFoodtypesByCourse(
      currentCourseOption,
      recipesContent
    );
    if (isEmpty(filteredRecipesContent)) {
      setCurrentFoodTypeOption(firstFoodTypeOption);
      setCurrentProductOption(firstProductOption);
      setFoodtypeOptions([
        DROPDOWN_DEFAULT_VALUE_FOOD_TYPE,
        ...foodtypesByCourseTabs
      ]);
      setProductOptions(productOptions);
    } else {
      const productTypesByFilteredRecipes =
        generateProductTypesByFilteredRecipes(filteredRecipesContent);

      setFoodtypeOptions([
        DROPDOWN_DEFAULT_VALUE_FOOD_TYPE,
        ...foodtypesByCourseTabs
      ]);
      setProductOptions([
        DROPDOWN_DEFAULT_VALUE_PRODUCTS,
        ...productTypesByFilteredRecipes
      ]);
    }
  }, [currentCourseOption.value]);

  useEffect(() => {
    if (isEmpty(filteredRecipesContent)) {
      const foodtypesByCourseTabs = generateFoodtypesByCourse(
        currentCourseOption,
        recipesContent
      );

      setCurrentFoodTypeOption(firstFoodTypeOption);
      setFoodtypeOptions([
        DROPDOWN_DEFAULT_VALUE_FOOD_TYPE,
        ...foodtypesByCourseTabs
      ]);
    } else {
      const productTypesByFilteredRecipes =
        generateProductTypesByFilteredRecipes(filteredRecipesContent);

      setProductOptions([
        DROPDOWN_DEFAULT_VALUE_PRODUCTS,
        ...productTypesByFilteredRecipes
      ]);
    }
  }, [currentFoodTypeOption.value]);

  function handleResetFilters() {
    setCurrentCourseOption(firstCourseOption);
    setCurrentFoodTypeOption(firstFoodTypeOption);
    setCurrentProductOption(firstProductOption);
  }

  return {
    currentCourseOption,
    currentFoodTypeOption,
    currentProductOption,
    foodtypeOptions,
    productsOptions,
    handleResetFilters,
    setCurrentCourseOption,
    setCurrentFoodTypeOption,
    setCurrentProductOption
  };
};
